import React from 'react';
import { KpiCard } from './KpiCard';
interface HeaderProps {
  stats: {
    activeQueue: number;
    attemptedToday: number;
    connectedToday: number;
    convertedToday: number;
    conversionRate: number;
  };
}
export function Header({
  stats
}: HeaderProps) {
  return <div className="bg-white border-b border-slate-200 px-8 py-6" data-id="element-105">
      <div className="flex items-start justify-between gap-6" data-id="element-106">
        <div className="flex items-start gap-5" data-id="element-107">
          <div className="border-2 border-brand-orange-500 rounded px-3 py-2 flex flex-col items-center leading-none flex-shrink-0" data-id="element-108">
            <span className="text-brand-navy-900 font-bold text-sm tracking-wide" data-id="element-109">
              UNITED MORTGAGE
            </span>
            <span className="text-brand-orange-500 text-[10px] tracking-[0.3em] mt-0.5" data-id="element-110">
              LENDING
            </span>
          </div>
          <div data-id="element-111">
            <h1 className="text-3xl font-bold text-brand-navy-900" data-id="element-112">
              Past Client Engagement Hub
            </h1>
            <div className="h-1 w-16 bg-brand-orange-500 rounded-full mt-2 mb-2" data-id="element-113" />
            <p className="text-slate-600" data-id="element-114">
              Manage and re-engage previous borrowers to generate new loan
              opportunities.
            </p>
          </div>
        </div>

        <div className="flex gap-3 flex-shrink-0" data-id="element-115">
          <KpiCard label="Active Queue" value={stats.activeQueue} color="navy" data-id="element-116" />
          <KpiCard label="Attempted Today" value={stats.attemptedToday} color="orange" data-id="element-117" />
          <KpiCard label="Connected Today" value={stats.connectedToday} color="blue" data-id="element-118" />
          <KpiCard label="Converted Today" value={stats.convertedToday} color="green" data-id="element-119" />
          <KpiCard label="Conversion Rate" value={`${stats.conversionRate}%`} delta="+2.3%" trend="up" color="orange" data-id="element-120" />
        </div>
      </div>
    </div>;
}